import Tabs from 'src/ui/molecules/Tabs'
import MintToken from './actions/token/MintToken'
import BurnToken from './actions/token/BurnToken'
import PauseToken from './actions/token/PauseToken'
import FreezeToken from './actions/token/FreezeToken'
import WipeToken from './actions/token/WipeToken'
import ApproveToken from './actions/token/ApproveToken'
import UpdateToken from './actions/token/UpdateToken'
import ProjectEvents from './ProjectEvents'

import { IProject } from './useProjectApi'

const TokenProject = ({ project }: { project: IProject }) => {
  let chain = project.data.chain
  const { canBurn, canMint, canFreeze, canPause, canWipe } = project.properties

  const mvxEsdtProperties = [
    { label: 'Pausable', value: 'canPause' },
    { label: 'Freezable', value: 'canFreeze' },
    { label: 'Wipeable', value: 'canWipe' },
    { label: 'Changeable Owner', value: 'canChangeOwner' },
    { label: 'Upgradable', value: 'canUpgrade' },
    { label: 'Can Add Special Roles', value: 'canAddSpecialRoles' },
  ]
  const allEsdtProperties = [
    {
      label: 'Mintable',
      value: 'canMint',
    },
    {
      label: 'Burnable',
      value: 'canBurn',
    },
  ]

  if (chain === 'multiversx') {
    allEsdtProperties.push(...mvxEsdtProperties)
  }

  const tabData = []
  canMint &&
    tabData.push({
      title: 'Mint',
      content: <MintToken project={project} />,
    })
  canBurn &&
    tabData.push({
      title: 'Burn',
      content: <BurnToken project={project} />,
    })
  canFreeze &&
    tabData.push({
      title: 'Freeze',
      content: <FreezeToken project={project} />,
    })
  canPause &&
    tabData.push({
      title: 'Pause',
      content: <PauseToken project={project} />,
    })
  canWipe &&
    tabData.push({
      title: 'Wipe',
      content: <WipeToken project={project} />,
    })
  chain !== 'multiversx' &&
    tabData.push({
      title: 'Approve',
      content: <ApproveToken project={project} />,
    })

  return tabData.length ? (
    <>
      {project.hasSubscription && <ProjectEvents project={project} />}
      <UpdateToken project={project} />

      <div className="flex flex-col flex-wrap gap-4">
        <h2>Actions</h2>
        <div className="flex flex-row flex-wrap gap-6">
          <Tabs tabs={tabData} />
        </div>
      </div>
    </>
  ) : null
}

export default TokenProject
